/* fieldset.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./fieldset.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Legend } from './label';
var fieldSetStyles = null;

/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */
var Fieldset = function Fieldset(_ref) {
  var children = _ref.children,
    legend = _ref.legend;
  return /*#__PURE__*/React.createElement("fieldset", {
    className: ax(["_1pfhu2gc"])
  }, legend && /*#__PURE__*/React.createElement(Legend, null, legend), children);
};
export default Fieldset;